const TrustBar = () => (
  <section className="trust-bar">
    <div className="trust-item">
      <div className="trust-icon">✦</div>
      <div className="trust-title">100% Authentic</div>
      <div className="trust-text">
        Every timepiece is verified for authenticity at the hands of our experts and is backed by warranty policies.
      </div>
    </div>
    <div className="trust-item">
      <div className="trust-icon">◆</div>
      <div className="trust-title">Best Price Guarantee</div>
      <div className="trust-text">
        With competitive and honest pricing on all luxury watches, we guarantee the best value on the market.
      </div>
    </div>
    <div className="trust-item">
      <div className="trust-icon">❖</div>
      <div className="trust-title">Complete Services</div>
      <div className="trust-text">
        Buy, sell, trade-in, mechanical services - everything you need in one place.
      </div>
    </div>
  </section>
);

export default TrustBar;
